<!-- Toolbar / Header -->
<div #header class="w-full">
  <app-modal-header
    #modal_header
    [isDialog]="isDialog"
    [state]="state"
    [label]="title"
    (onOkClick)="doOk($event)"
    (onEditAndSaveClick)="doEditAndSave($event)"
    (onReady)="modalHeaderReady($event)"
    (onCancelClick)="doCancel($event)"
  >
  </app-modal-header>
</div>

<div class="jk-content">
  <div>
    <div class="ai-section-header"><mat-divider></mat-divider></div>
    <div class="flex gap-2 w-full">
      <app-jkcheckboxYN
        class="shrink-0"
        label="星號"
        #WD027Com
        id="WD027"
        [(valueYN)]="item.WD027"
        [readonly]="isBrowse"
      >
      </app-jkcheckboxYN>
      <app-jkdatefield
        class="shrink-0"
        label="工作日期"
        #WD002Com
        id="WD002"
        [value]="item.WD002"
        (valueChange)="WD002Change($event)"
        [required]="true"
        placeholder="工作日期"
        [readonly]="isBrowse"
      >
      </app-jkdatefield>
      <app-jkedit
        class="w-16 shrink-0"
        label="星期"
        #WD018Com
        id="WD018"
        [(value)]="item.WD018"
        placeholder="星期"
        [readonly]="isBrowse"
      >
      </app-jkedit>
      <div class="w-36 shrink-0">
        <app-jkcombobox
          class="jk-combobox-border w-full"
          [styleDisplay]="'flex'"
          labelMode="floating"
          label="格式"
          valueExpr="id"
          displayExpr="idName"
          [(value)]="item.WD029"
          [showClearButton]="true"
          [required]="true"
          [items]="srv.MtrWd029List"
        >
        </app-jkcombobox>
      </div>
      <app-jkedit
        class="flex-1 min-w-0"
        label="主旨"
        #WD004Com
        id="WD004"
        [(value)]="item.WD004"
        placeholder="主旨"
        [readonly]="isBrowse"
      >
      </app-jkedit>
    </div>
    <div class="flex">
            @if (item.WD029 === "M") {
        <app-milkdown-markdown-editor
          [label]="'內文(markdown)'"
          [markdown]="content()"
          (markdownChange)="editContent($event)"
          [darkMode]="false"
          [path]="getImagePath(item)" [host]="srv.host"
        ></app-milkdown-markdown-editor>
            }
            @if (item.WD029 === "T") {
              <app-jktextarea
                class="w-full block"
                label="內文"
                [displayLabel]="true"
                [(value)]="item.WD032"
                height="200px"
                [readOnly]="true"
              >
              </app-jktextarea>
            }
            @if (item.WD029 === "H") {
              <app-jk-rich-editor
                class="w-full block"
                [minHeight]="'200px'"
                label="html內文"
                #WL016Com
                id="WL016"
                [(value)]="item.WD026"
                placeholder="htm內文"
                [readonly]="isBrowse"
                [path]="getImagePath(item)"
                [host]="srv.host"
              >
              </app-jk-rich-editor>
            }

    </div>
    <div class="flex w-full gap-2">
      <app-jkcombobox
        class="flex-1 basis-0 min-w-0"
        label="大分類"
        #WD015Com
        id="WD015"
        [(value)]="item.WD015"
        [items]="srv.MtrWd015List"
        [readonly]="isBrowse"
      >
      </app-jkcombobox>
      <app-jkcombobox
        class="flex-1 basis-0 min-w-0"
        label="中分類"
        #WD016Com
        id="WD016"
        [(value)]="item.WD016"
        [items]="srv.getMtrwd016List(item.WD015)"
        [readonly]="isBrowse"
      >
      </app-jkcombobox>
      <app-jkcombobox
        class="flex-1 basis-0 min-w-0"
        label="小分類"
        #WD024Com
        id="WD024"
        [(value)]="item.WD024"
        [items]="srv.getMtrwd024List(item.WD015, item.WD016)"
        [readonly]="isBrowse"
      >
      </app-jkcombobox>
    </div>
    <div class="ai-section-header"><mat-divider></mat-divider></div>
    <div class="flex">
      <app-jkbtnedit
        label="工作者"
        #WD014Com
        id="WD014"
        [(value)]="item.WD014"
        [displayName]="itemAny.WD014C"
        maintable="CMSMV"
        item="W01"
        valueExpr="MV001"
        displayExpr="MV002"
        placeholder="工作者"
        [readonly]="isBrowse"
        (valueChange)="WD014Change($event)"
      >
      </app-jkbtnedit>
      <app-jkbtnedit
        label="客戶代號"
        #WD021Com
        id="WD021"
        [(value)]="item.WD021"
        [required]="true"
        [displayName]="itemAny.WD021C"
        maintable="COPMA"
        item="W01"
        valueExpr="MA001"
        displayExpr="MA002"
        placeholder="客戶代號"
        [readonly]="isBrowse"
        (valueChange)="WD021Change($event)"
      >
      </app-jkbtnedit>
      <app-jknumberedit
        label="計費時數"
        #WD025Com
        id="WD025"
        [(value)]="item.WD025"
        placeholder="計費時數"
        [readonly]="isBrowse"
      >
      </app-jknumberedit>
    </div>
    <div class="ai-section-header"><mat-divider></mat-divider></div>
    <div class="flex gap-2 ">
      <app-jkcombobox class="min-w-20"
        label="狀態"
        #WD011Com
        id="WD011"
        [(value)]="item.WD011"
        [items]="srv.MtrWd011List"
        [readonly]="isBrowse"
      >
      </app-jkcombobox>
      <app-jkcheckboxYN
        label="結案碼"
        #WD017Com
        id="WD017"
        [(valueYN)]="item.WD017"
        [readonly]="isBrowse"
      >
      </app-jkcheckboxYN>
    </div>
    <div class="ai-section-header"><mat-divider></mat-divider></div>
    <div class="flex">
      <app-jkcheckboxYN
        label="提醒碼"
        #WD010Com
        id="WD010"
        [(valueYN)]="item.WD010"
        [readonly]="isBrowse"
      >
      </app-jkcheckboxYN>
      <app-jkdatefield
        label="提醒日期"
        #WD005Com
        id="WD005"
        [(value)]="item.WD005"
        placeholder="提醒日期"
        [readonly]="isBrowse"
      >
      </app-jkdatefield>
      <app-jktext label="提醒時間" [value]="item.WD006"> </app-jktext>
    </div>
    <div class="ai-section-header"><mat-divider></mat-divider></div>
    <div class="flex">
      <app-jkedit
        label="優先順序"
        #WD012Com
        id="WD012"
        [(value)]="item.WD012"
        placeholder="優先順序"
        [readonly]="isBrowse"
      >
      </app-jkedit>
      <app-jknumberedit
        label="進度"
        #WD013Com
        id="WD013"
        [(value)]="item.WD013"
        placeholder="進度"
        [readonly]="isBrowse"
      >
      </app-jknumberedit>
      <app-jknumberedit
        label="預估時數"
        #WD020Com
        id="WD020"
        [(value)]="item.WD020"
        placeholder="預估時數"
        [readonly]="isBrowse"
      >
      </app-jknumberedit>
    </div>
    <div class="ai-section-header"><mat-divider></mat-divider></div>
    <div class="flex">
      <app-jkcheckboxYN
        label="私人的"
        #WD022Com
        id="WD022"
        [(valueYN)]="item.WD022"
        [readonly]="isBrowse"
      >
      </app-jkcheckboxYN>
      <app-jkcombobox
        label="週期"
        #WD023Com
        id="WD023"
        [(value)]="item.WD023"
        [items]="srv.MtrWd023List"
        [readonly]="isBrowse"
      >
      </app-jkcombobox>
      <app-jknumberedit
        label="金額"
        #WD019Com
        id="WD019"
        [(value)]="item.WD019"
        placeholder="金額"
        [readonly]="isBrowse"
      >
      </app-jknumberedit>
    </div>
    <div class="ai-section-header"><mat-divider></mat-divider></div>
    <div class="flex">
      <app-jktext label="來源單號" [value]="item.WD028"> </app-jktext>
      <app-jktext label="建檔時間" [value]="item.WD001"> </app-jktext>
    </div>
  </div>
</div>
<mat-toolbar class="jk-footer-toolbar"> </mat-toolbar>
<!-- 單頭編輯結束 -->
